import { Component, OnInit } from "@angular/core";
import { AuthService } from "../../services/auth.service";
import { RoleNames } from "../../constants/role-names";

// Metadata
export class RouteInfo {
  path?: string;
  title?: string;
  type?: string;
  collapse?: string;
  icontype?: string;
  children?: ChildrenItems[];
  badge? = "";
  showBadge? = false;
}

export class ChildrenItems {
  path?: string;
  title?: string;
  ab?: string;
  type?: string;
}

// Menu Items

export const ADMINUPPERROUTES: RouteInfo[] = [
  // {path: '/dashboard/profile', title: 'Profile', type: 'link', icontype: 'fas fa fa-user'},
  {
    path: "/dashboard/change-password",
    title: "Change Password",
    type: "link",
    icontype: "fas fa fa-key",
  },
  {
    path: "/logout",
    title: "Logout",
    type: "link",
    icontype: "fas fa fa-sign-out-alt",
  },
];
// export const STAFFROUTES: RouteInfo[] = [
//   {path: '/dashboard/staff-home', title: 'Home', type: 'link', icontype: 'fas fa fa-home'},
//   {path: '/dashboard/notifications', title: 'Notifications', type: 'link', icontype: 'fas fa fa-bell', showBadge: true, badge: '10'},
//   {
//     path: '/dashboard/customers/', title: 'Customers', type: 'sub', icontype: 'fas fa fa-users', collapse: 'customers', children: [
//       {path: 'create', title: 'Create Customer', ab: 'CC', type: 'link'},
//       {path: 'view', title: 'View Customer', ab: 'VC', type: 'link'},
//     ]
//   },
//   {
//     path: '/dashboard/equipments/', title: 'Equipments', type: 'sub', icontype: 'fas fa fa-dolly', collapse: 'devices', children: [
//       {path: 'create', title: 'Create Equipment', ab: 'CE', type: 'link'},
//       {path: 'view', title: 'View Equipment', ab: 'VE', type: 'link'},
//     ]
//   },
//   {
//     path: '/dashboard/workers/', title: 'Worker', type: 'sub', icontype: 'fas fa fa-briefcase', collapse: 'workers', children: [
//       {path: 'create', title: 'Create Worker', ab: 'CW', type: 'link'},
//       {path: 'view', title: 'View Worker', ab: 'VW', type: 'link'},
//     ]
//   },
//   {
//     path: '/dashboard/jobs/', title: 'Jobs', type: 'sub', icontype: 'fas fa fa-clipboard-list', collapse: 'jobs', children: [
//       {path: 'create', title: 'Create Job', ab: 'CJ', type: 'link'},
//       {path: 'view', title: 'View Job', ab: 'VJ', type: 'link'},
//     ]
//   },
//   {path: '/dashboard/broadcasts/', title: 'Broadcasts', type: 'link', icontype: 'fas fa fa-bullhorn', collapse: 'broadcasts'},
//   {path: '/dashboard/chats/', title: 'Chats', type: 'link', icontype: 'fas fa fa-comment', collapse: 'chats'},
//   {
//     path: '/dashboard/worker-tracking-location/',
//     title: 'Tracking',
//     type: 'link',
//     icontype: 'fas fa fa-map-marker-alt',
//     collapse: 'broadcasts'
//   },
//   {
//     path: '/dashboard/form-builders/',
//     title: 'Form Builders',
//     type: 'sub',
//     icontype: 'fas fa fa-clipboard-check',
//     collapse: 'inquiry-forms',
//     children: [
//       {path: 'create', title: 'Create Form', ab: 'CF', type: 'link'},
//       {path: 'view', title: 'View Form', ab: 'VF', type: 'link'},
//     ]
//   },
//   // {
//   //   path: '/dashboard/tickets/', title: 'Tickets', type: 'sub', icontype: 'fas fa fa-ticket-alt', collapse: 'tickets', children: [
//   //     {path: 'resolved', title: 'Resolved', ab: 'R', type: 'link'},
//   //     {path: 'pending', title: 'Pending', ab: 'P', type: 'link'},
//   //   ]
//   // },
//   {path: '/dashboard/company-services', title: 'Company services', type: 'link', icontype: 'fas fa fa-network-wired'},
//   {
//     path: '/dashboard/settings/', title: 'Settings', type: 'sub', icontype: 'fas fa fa-cogs', collapse: 'settings', children: [
//       {path: 'company-logo', title: 'Company Logo', ab: 'CL', type: 'link'},
//     ]
//   },
// ];
//
// export const COMPANYROUTES: RouteInfo[] = [
//   {path: '/dashboard/company-home', title: 'Home', type: 'link', icontype: 'fas fa fa-home'},
//   {path: '/dashboard/notifications', title: 'Notifications', type: 'link', icontype: 'fas fa fa-bell', showBadge: true, badge: '10'},
// // {
//   //   path: '/dashboard/customers/', title: 'Customers', type: 'sub', icontype: 'fas fa fa-users', collapse: 'customers', children: [
//   //     {path: 'create', title: 'Create Customer', ab: 'CC', type: 'link'},
//   //     {path: 'view', title: 'View Customer', ab: 'VC', type: 'link'},
//   //   ]
//   // },
//   {
//     path: '/dashboard/staffs/', title: 'Staff', type: 'sub', icontype: 'fas fa fa-id-badge', collapse: 'staffs', children: [
//       {path: 'create', title: 'Create Staff', ab: 'CM', type: 'link'},
//       {path: 'view', title: 'View Staff', ab: 'VM', type: 'link'},
//     ]
//   },
//   {
//     path: '/dashboard/workers/', title: 'Worker', type: 'sub', icontype: 'fas fa fa-briefcase', collapse: 'workers', children: [
//       {path: 'create', title: 'Create Worker', ab: 'CW', type: 'link'},
//       {path: 'view', title: 'View Worker', ab: 'VW', type: 'link'},
//     ]
//   },
//   // {
//   //   path: '/dashboard/inquiry-forms/',
//   title: 'Form Builders', type: 'sub', icontype: 'fas fa fa-clipboard-check', collapse: 'inquiry-forms', children: [
//   //     {path: 'create', title: 'Create Form', ab: 'CF', type: 'link'},
//   //     {path: 'view', title: 'View Form', ab: 'VF', type: 'link'},
//   //   ]
//   // },
//   {
//     path: '/dashboard/tickets/', title: 'Tickets', type: 'sub', icontype: 'fas fa fa-ticket-alt', collapse: 'tickets', children: [
//       {path: 'resolved', title: 'Resolved', ab: 'R', type: 'link'},
//       {path: 'pending', title: 'Pending', ab: 'P', type: 'link'},
//     ]
//   },
//   {path: '/dashboard/company-services', title: 'Company services', type: 'link', icontype: 'fas fa fa-network-wired'},
//   {path: '/dashboard/company-settings', title: 'Settings', type: 'link', icontype: 'fas fa fa-cog'},
// ];

export const ADMINROUTES: RouteInfo[] = [
  {
    path: "/dashboard/home",
    title: "Home",
    type: "link",
    icontype: "fas fa fa-home",
  },
  {
    path: "/dashboard/merchants",
    title: "Merchants",
    type: "link",
    icontype: "fas fa fa-users",
  },
  // {
  //   path: '/dashboard/companies/', title: 'Companies', type: 'sub', icontype: 'fas fa fa-building', collapse: 'components', children: [
  //     {path: 'create', title: 'Create Company', ab: 'CC', type: 'link'},
  //     {path: 'view', title: 'View Companies', ab: 'VC', type: 'link'},
  //   ]
  // },
  // {
  //   path: '/dashboard/tickets/', title: 'Tickets', type: 'sub', icontype: 'fas fa fa-ticket-alt', collapse: 'tickets', children: [
  //     {path: 'resolved', title: 'Resolved', ab: 'R', type: 'link'},
  //     {path: 'pending', title: 'Pending', ab: 'P', type: 'link'},
  //   ]
  // },
  // {path: '/dashboard/business-types', title: 'Business Types', type: 'link', icontype: 'fas fa fa-network-wired'},
  // {
  //   path: '/dashboard/settings/', title: 'Settings', type: 'sub', icontype: 'fas fa fa-cogs', collapse: 'settings', children: [
  //     {path: 'company-logo', title: 'Company Logo', ab: 'CL', type: 'link'},
  //   ]
  // },
];

export const MERCHANTROUTES: RouteInfo[] = [
  {
    path: "/dashboard/merchant-home",
    title: "Home",
    type: "link",
    icontype: "fas fa fa-home",
  },
  {
    path: "/dashboard/transactions",
    title: "Transactions",
    type: "link",
    icontype: "fas fa fa-cash-register",
  },
  {
    path: "/dashboard/categories",
    title: "Categories",
    type: "link",
    icontype: "fas fa fa-sitemap",
  },
  {
    path: "/dashboard/sub-categories",
    title: "Sub-categories",
    type: "link",
    icontype: "fas fa fa-bezier-curve",
  },
  {
    path: "/dashboard/products",
    title: "Products",
    type: "link",
    icontype: "fas fa fa-shopping-cart",
  },
  {
    path: "/dashboard/customers",
    title: "Customers",
    type: "link",
    icontype: "fas fa fa-user-friends",
  },
  {
    path: "/dashboard/suppliers",
    title: "Suppliers",
    type: "link",
    icontype: "fas fa fa-people-carry",
  },
  {
    path: "/dashboard/employee",
    title: "employee",
    type: "link",
    icontype: "fas fa fa-user-tie",
  },
  {
    path: "/dashboard/inventories",
    title: "Inventories",
    type: "link",
    icontype: "fas fa fa-warehouse",
  },
  {
    path: "/dashboard/brands",
    title: "Brands",
    type: "link",
    icontype: "fas fa fa-copyright",
  },
  {
    path: "/dashboard/expenses",
    title: "Expense",
    type: "link",
    icontype: "fas fa fa-money",
  },
  {
    path: "/dashboard/sales/",
    title: "Sales",
    type: "sub",
    icontype: "fas fa fa-chart-line",
    collapse: "sales",
    children: [
      { path: "create", title: "Create Sale", ab: "CS", type: "link" },
      { path: "view", title: "View Sale", ab: "VS", type: "link" },
    ],
  },
  {
    path: "/dashboard/sale-returns/",
    title: "Sale Returns",
    type: "sub",
    icontype: "fas fa fa-chart-line",
    collapse: "sale-returns",
    children: [
      { path: "create", title: "Create Sale Return", ab: "CSR", type: "link" },
      { path: "view", title: "View Sale Return", ab: "VSR", type: "link" },
    ],
  },
  {
    path: "/dashboard/purchases/",
    title: "purchases",
    type: "sub",
    icontype: "fas fa fa-chart-line",
    collapse: "purchases",
    children: [
      { path: "create", title: "Create Purchase", ab: "CP", type: "link" },
      { path: "view", title: "View Purchase", ab: "VP", type: "link" },
    ],
  },
  {
    path: "/dashboard/purchase-returns/",
    title: "Purchase Returns",
    type: "sub",
    icontype: "fas fa fa-chart-line",
    collapse: "purchase-returns",
    children: [
      {
        path: "create",
        title: "Create Purchase Return",
        ab: "CPR",
        type: "link",
      },
      { path: "view", title: "View Purchase Return", ab: "VPR", type: "link" },
    ],
  },
  {
    path: "/dashboard/settings/",
    title: "Settings",
    type: "sub",
    icontype: "fas fa fa-cog",
    collapse: "settings",
    children: [
      { path: "info", title: "info", ab: "I", type: "link" },
      { path: "tax", title: "Tax", ab: "T", type: "link" },
      { path: "code", title: "Code", ab: "C", type: "link" },
    ],
  },

  // {
  //   path: '/dashboard/tickets/', title: 'Tickets', type: 'sub', icontype: 'fas fa fa-ticket-alt', collapse: 'tickets', children: [
  //     {path: 'resolved', title: 'Resolved', ab: 'R', type: 'link'},
  //     {path: 'pending', title: 'Pending', ab: 'P', type: 'link'},
  //   ]
  // },
  // {path: '/dashboard/business-types', title: 'Business Types', type: 'link', icontype: 'fas fa fa-network-wired'},
  // {
  //   path: '/dashboard/settings/', title: 'Settings', type: 'sub', icontype: 'fas fa fa-cogs', collapse: 'settings', children: [
  //     {path: 'company-logo', title: 'Company Logo', ab: 'CL', type: 'link'},
  //   ]
  // },
];

export const EmployeeROUTES: RouteInfo[] = [
  {
    path: "/dashboard/categories",
    title: "Categories",
    type: "link",
    icontype: "fas fa fa-sitemap",
  },
  {
    path: "/dashboard/sub-categories",
    title: "Sub-categories",
    type: "link",
    icontype: "fas fa fa-bezier-curve",
  },
  {
    path: "/dashboard/products",
    title: "Products",
    type: "link",
    icontype: "fas fa fa-shopping-cart",
  },
  {
    path: "/dashboard/inventories",
    title: "Inventories",
    type: "link",
    icontype: "fas fa fa-warehouse",
  },
  {
    path: "/dashboard/brands",
    title: "Brands",
    type: "link",
    icontype: "fas fa fa-copyright",
  },
  {
    path: "/dashboard/sales/",
    title: "Sales",
    type: "sub",
    icontype: "fas fa fa-chart-line",
    collapse: "sales",
    children: [
      { path: "create", title: "Create Sale", ab: "CS", type: "link" },
    ],
  },
];

@Component({
  selector: "app-sidebar",
  templateUrl: "sidebar.component.html",
})
export class SidebarComponent implements OnInit {
  public static Routes?: RouteInfo[];
  notificationCount = 0;
  currentRoutes?: RouteInfo[];
  upperMenuRoutes?: RouteInfo[];

  constructor(private authService: AuthService) {}

  isNotMobileMenu(): boolean {
    return window.outerWidth <= 991;
  }

  initHandlers(): void {}

  getNotificationBadge(): string {
    return this.notificationCount + "";
  }

  ngOnInit(): void {
    this.initHandlers();
    if (this.authService.isRole(RoleNames.Administrator)) {
      this.currentRoutes = ADMINROUTES.filter(() => true);
      this.upperMenuRoutes = ADMINUPPERROUTES.filter(() => true);
    }
    // if (this.authService.isRole(RoleNames.Merchant)) {
    //   this.currentRoutes = MERCHANTROUTES.filter(() => true);
    //   this.upperMenuRoutes = ADMINUPPERROUTES.filter(() => true);
    // }
    // if (this.authService.isRole(RoleNames.Employee)) {
    //   this.currentRoutes = EmployeeROUTES.filter(() => true);
    //   this.upperMenuRoutes = ADMINUPPERROUTES.filter(() => true);
    // }
    SidebarComponent.Routes = this.currentRoutes?.filter(() => true);
  }

  getProfileImage(): string {
    return this.authService.currentUser.image ?? "";
  }

  getProfileName(): string {
    return this.authService.currentUser.fullName as string;
  }
}
